import { IconNames } from "../../Icon/types";
import { subdomainTypes } from "../../../context/availableSubdomains";

type BranchRoute = {
  [key in subdomainTypes]: string;
};

interface MenuLink {
  title: string;
  route: string | BranchRoute;
  icon?: IconNames;
  category: string;
  externalLink?: boolean;
  description?: string;
  fullWidth?: boolean; // Makes the link span all columns
  mobileHidden?: boolean;
  brand?: string;
}

export interface MenuSection {
  title: string;
  links: MenuLink[];
  itemsPerRow?: number; // Default is 3
}

const webstoreLinks: MenuSection = {
  title: "Webstore",
  itemsPerRow: 3,
  links: [
    {
      title: "Cart",
      category: "cart",
      route: "/store/cart",
      icon: "ShoppingCartWhite",
    },
    {
      title: "Quick Order",
      category: "quickorder",
      route: "/quick-order",
      icon: "Pencil",
      mobileHidden: true,
    },
    {
      title: "Saved Orders",
      category: "savedorders",
      route: "/saved-orders",
      icon: "Save",
    },
    {
      title: "Order Import",
      category: "orderimport",
      route: "/order-uploader",
      icon: "FileUpload",
    },
    {
      title: "Order History",
      category: "orderhistory",
      route: "/order-history",
      icon: "BoxOpen",
    },
    {
      title: "Transactions",
      category: "transactions",
      route: "/transactions",
      icon: "CreditCard",
    },
    {
      title: "Preferences",
      category: "preferences",
      route: "/preferences",
      icon: "Cog",
    },
  ],
};

const resourcesLinks: MenuSection = {
  title: "Resources",
  itemsPerRow: 2,
  links: [
    {
      title: "Media Library",
      category: "medialibrary",
      fullWidth: true,
      route: {
        [subdomainTypes.NZ]:
          "https://drive.google.com/drive/folders/1b0psR81rxlQPe_O8t4WkgyUHVx9Mq_i2?usp=drive_link",
        [subdomainTypes.AU]:
          "https://drive.google.com/drive/folders/1b0psR81rxlQPe_O8t4WkgyUHVx9Mq_i2?usp=drive_link",
        [subdomainTypes.CA]:
          "https://drive.google.com/drive/folders/1QDN3EFfMZM4irzpMhDlB9TpMK8gsTaue",
      },
      icon: "PhotoVideo",
      externalLink: true,
      description:
        "Check out our new media library layout, with everything you need in one easy-to-navigate location",
    },
    {
      title: "Digital Catalogues",
      category: "digitalcatalogues",
      route: {
        [subdomainTypes.NZ]: "https://www.fashionbiz.co.nz/catalogue",
        [subdomainTypes.AU]: "https://www.fashionbiz.com.au/catalogue",
        [subdomainTypes.CA]: "https://www.fashionbiz.ca/catalogue",
      },
      icon: "StarWhite",
      externalLink: true,
    },
    {
      title: "Web Data",
      category: "webdata",
      route: {
        [subdomainTypes.NZ]:
          "https://drive.google.com/drive/folders/1GxxxRt9NfumwrIv8S70jA6_yqoCuNGgz?usp=drive_link",
        [subdomainTypes.AU]:
          "https://drive.google.com/drive/folders/1JpiF1ou0_c98p9jiuKC2taPC5bz3caux?usp=drive_link",
        [subdomainTypes.CA]:
          "https://drive.google.com/drive/folders/1QDN3EFfMZM4irzpMhDlB9TpMK8gsTaue?usp=drive_link",
      },
      icon: "PhotoVideo",
      externalLink: true,
    },
  ],
};

const brandsLinks: MenuSection = {
  title: "Brands",
  itemsPerRow: 3,
  links: [
    {
      title: "Biz Collection",
      category: "bizcollection",
      route: "products/biz-collection?page=1",
      brand: "biz-collection",
    },
    {
      title: "Biz Corporates",
      category: "bizcorporates",
      route: "products/biz-corporates?page=1",
      brand: "biz-corporates",
    },
    {
      title: "Syzmik",
      category: "syzmik",
      route: "products/syzmik?page=1",
      brand: "syzmik",
    },
    {
      title: "Syzmik Boots",
      category: "syzmik-boots",
      route: "products/syzmik-boots?page=1",
      brand: "syzmik-boots",
    },
    {
      title: "GOODMATES",
      category: "goodmates",
      route: "products/good-mates?page=1",
      brand: "good-mates",
    },
    {
      title: "Inaura",
      category: "inaura",
      route: "products/inaura?page=1",
      brand: "inaura",
    },
    {
      title: "Direct Group",
      category: "directgroup",
      route: "products/direct-group?page=1",
      brand: "direct-group",
    },
  ],
};
export { resourcesLinks };
export const menuLinks: MenuSection[] = [webstoreLinks, brandsLinks];
